import { Component, Input } from "@angular/core";
import { FormGroup } from "@angular/forms";
import { faSearch } from "@fortawesome/free-solid-svg-icons";
import {
  catchError,
  debounceTime,
  distinctUntilChanged,
  map,
  Observable,
  of,
  OperatorFunction,
  switchMap,
  tap,
} from "rxjs";
import { ILocalization } from "src/app/calendar/interfaces/tipo-localizacion";
import { CalendarService } from "src/app/calendar/services/tipoSesion/calendar.service";

@Component({
  selector: "app-location-search",
  templateUrl: "./location-search.component.html",
  styleUrls: ["./location-search.component.css"],
})
export class LocationSearchComponent {
  @Input() FormGroup!: FormGroup;
  @Input() controlName!: string;

  isLoadingLocationSearch = false;
  protected faSearch = faSearch;

  constructor(private calendarService: CalendarService) {}

  public searchLocationFilter: OperatorFunction<
    string,
    readonly ILocalization[]
  > = (text$: Observable<string>) =>
    text$.pipe(
      debounceTime(1500),
      distinctUntilChanged(),
      switchMap(term => {
        if (term.length <= 3) {
          return of([]);
        }
        this.isLoadingLocationSearch = true;
        return this.calendarService
          .getLocationFromCornerStone(term, "name")
          .pipe(map(locations => locations.slice(0, 12)));
      }),
      tap(() => {
        this.isLoadingLocationSearch = false;
      }),
      catchError(e => {
        return of(e);
      })
    );

  resultFormatLocationListValue = (value: ILocalization) => value.name;
}
